import Snackbar from "@mui/material/Snackbar";
import SnackbarContent from "@mui/material/SnackbarContent";

import { ShiftClickFunction } from "~/hooks/useShiftSelect";

type ShiftSelectSnackbarProps = {
  isOpen: boolean;
  mode: ShiftClickFunction;
};

export function ShiftSelectSnackbar({
  isOpen,
  mode
}: ShiftSelectSnackbarProps) {
  return (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      open={isOpen}
    >
      <SnackbarContent
        message={mode === "select" ? "Select" : "Unselect"}
        sx={{
          width: 150,
          minWidth: 150,
          display: "flex",
          justifyContent: "center"
        }}
      />
    </Snackbar>
  );
}
